import {
  downloadIcsFile,
  generateGoogleCalendarUrl,
  isAndroid,
  isMobileDevice,
  CalendarEvent,
} from '@features/invite/lib/calendar-utils';
import { palette } from '@shared/tokens/palette.stylex';
import { FC, useEffect, useState } from 'react';
import { Button } from '@shared/ui/kit';

interface AddToCalendarButtonProps {
  event: CalendarEvent;
  buttonText?: string;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const AddToCalendarButton: FC<AddToCalendarButtonProps> = ({
  event,
  buttonText = 'Добавить в календарь',
  onSuccess,
  onError,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isAndroidDevice, setIsAndroidDevice] = useState(false);

  useEffect(() => {
    setIsMobile(isMobileDevice());
    setIsAndroidDevice(isAndroid());
  }, []);

  const handleAddToCalendar = () => {
    try {
      if (isAndroidDevice) {
        // Для Android открываем Google Calendar
        const googleCalendarUrl = generateGoogleCalendarUrl(event);
        window.open(googleCalendarUrl, '_blank');
      } else {
        // Для iOS и отсальных (?) скачиваем ICS файл
        downloadIcsFile(event);
      }
    } catch (error) {
      onError?.(error as Error);
    }

    Promise.resolve().then(() => {
      onSuccess?.();
    });
  };

  if (!isMobile) {
    return null;
  }
  // TODO: Временное решение
  if (isMobile) {
    return null;
  }

  return (
    <Button
      onClick={handleAddToCalendar}
      variant="accent"
      size="medium"
      settings={{ fontSize: '18px', padding: '12px 24px', color: palette.greyWhite }}
    >
      {buttonText}
    </Button>
  );
};
